import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { PhoneSupport } from './phone-support.model';

export const SUPPORT_SCHEMA = Object.freeze({
  PHONE_SUPPORT: PhoneSupport,
});
export const RECORD = generateSchema(SUPPORT_SCHEMA);
export const KEYS: any = generateKeys(SUPPORT_SCHEMA);

export class Support extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.PHONE_SUPPORT,
        value: props.get(KEYS.PHONE_SUPPORT)
          ? new PhoneSupport(this.phoneSupport)
          : null,
      },
    ]);

    return selfModel as Support;
  }

  get phoneSupport(): PhoneSupport {
    return this.get(KEYS.PHONE_SUPPORT);
  }
}
